import { render, staticRenderFns } from "./hotelMessage.vue?vue&type=template&id=8bcbf0ba"
import script from "./hotelMessage.vue?vue&type=script&lang=js"
export * from "./hotelMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports